import axios from "axios"
import baseURL from "../config/api"

export const post_Schedule = (data: any, userId: string, token: string) => {
    return axios({
        url: `${baseURL}schedules`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data,
        params: { userId }
    }).then(response => response.data);
}

export const post_BulkSchedule = (data: any[], userId: string, token: string) => {
    return axios({
        url: `${baseURL}schedules/CreateBulkSchedule`,
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data,
        params: { userId }
    }).then(response => response.data);
}

export const put_Schedule = (data: any, userId: string, token: string) => {
    return axios({
        url: `${baseURL}schedules`,
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        withCredentials: true,
        data: data,
        params: { userId }
    }).then(response => response.data);
}

export const delete_ScheduleByDate = (date: string, groupId: string, userId: string, token: string) => {
    return axios({
        url: `${baseURL}schedules/DeleteScheduleByDate/${date},${groupId},${userId}`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {
            userId
        }
    }).then(response => response.data);
}

export const delete_Schedule = (primaryKey: string, userId: string, token: string) => {
    return axios({
        url: `${baseURL}schedules`,
        method: "DELETE",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: {
            id: primaryKey,
            userId
        }
    }).then(response => response.data);
}

export const getWeekSchedule = (date: string, groupId: number, token: string) => {
    return getFetch(`schedules/GetWeekSchedule/${date},${groupId}`, token)
}

export const getSchedule = (primaryKey: string, token: string) => {
    return getFetch(`schedules/${primaryKey}`, token)
}

const getFetch = (url: string, token: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        },
        params: params
    }).then(response => response.data);
}